module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-05-78eff83e2982626128a92e5e17582a03.svg";